// Module
var code = "<div ng-repeat=\"item in $ctrl.list\" class=\"list-content\" ng-transclude></div> <div ng-if=\"$ctrl.isListEmpty()\" class=\"alert alert-info\"> {{ 'core.list.no_items' | translate }} </div> <a class=\"btn btn-primary\" ng-click=\"$ctrl.addItem()\"> <sw-font-awesome name=\"plus\"></sw-font-awesome> &nbsp;{{ 'core.add' | translate }} </a> ";
// Exports
export default code;